import { TbArrowRight } from 'react-icons/tb'
import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import { LINKS } from 'routes/constants'
import { ChecklistTable } from 'routes/components/Features'
import { Link } from 'ui-kit/actions/link/Link'
import classes from './DifferenceEvaluation.module.scss'

export const DifferenceEvaluation = () => {
  return null

  return (
    <Block
      as={'section'}
      variant={'shadowMob'}
      pad={'baseMob'}
      divider={'mobile'}
      className={classes.section}
    >
      <Heading as={'h2'} size={'xl'} center className={classes.title}>
        We simply do more and better than any alternative. <br /> Checklist it
        yourself.
      </Heading>
      <div className={classes.content}>
        <div className={classes.description}>
          <Text size={'lg'} center balance className={classes.subtitle}>
            We compiled hundreds of evaluations into a comprehensive integration
            framework evaluation checklist.
          </Text>
          <Text size={'lg'} center balance className={classes.subtitle}>
            Use it to make an informed decision - it will be painful and
            expensive to change later.
          </Text>
        </div>

        <Link
          className={classes.link}
          asPageButton
          type='primary'
          href={LINKS.EVALUATION_CRITERIA}
        >
          View evaluation checklist
          <TbArrowRight className={classes.icon} />
        </Link>

        <div className={classes.visual}>
          <div className={classes.background} />
          <div className={classes.wrapper}>
            <ChecklistTable className={classes.table} />
          </div>
        </div>
      </div>
    </Block>
  )
}
